import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PhotoCriteriaDialog from '../Utility/PhotoCriteriaDialog';
import { ValidatorForm } from 'react-material-ui-form-validator';
import RadioValidatorElement from '../Utility/RadioValidatorElement';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    buttonItem: {
        marginTop: theme.spacing(2),
    },
    button: {
    },
});

interface IDocumentUploadPhotoConfirmationProps {
    photo: File;
    setPhoto: (photo) => void;
    setPhotoSubmited: (photoMarketingAccpeted: boolean) => void;
}

interface IDocumentUploadPhotoConfirmationState {
    viewingPhotoCriteria: boolean;
    photoConditionsSeen: boolean;
    photoConditionsAccepted: boolean | undefined;
    photoMarketingAccpeted: boolean | undefined;
    saving: boolean;
}

class DocumentUploadPhotoConfirmation extends Component<IDocumentUploadPhotoConfirmationProps & WithStyles<typeof styles>, IDocumentUploadPhotoConfirmationState> {
    constructor(props) {
        super(props);

        this.state = {
            viewingPhotoCriteria: false,
            photoConditionsSeen: false,
            photoConditionsAccepted: undefined,
            photoMarketingAccpeted: undefined,
            saving: false
        };

        ValidatorForm.addValidationRule('isBoolTrue', (value) => {
            return (value === true || value === "true");
        });
    }

    public componentDidMount() {
    }

    public componentWillUnmount() {
        ValidatorForm.removeValidationRule('isBoolTrue');
    }

    public render() {

        return (
            <Grid container>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Secure Document Management
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} >
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container justify="center" alignItems="center" spacing={1}>
                                <Grid item xs={12}>
                                    <Grid container justify="center" alignItems="center" >
                                        <img src={URL.createObjectURL(this.props.photo)} style={{ height: '400px', width: '300px', borderWidth: '1px', borderColor: '#c1c1c1', borderStyle: 'solid', borderRadius: '4px' }} />
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} sm={5} md={5}>
                                    <Button onClick={this.clearPhoto} color="primary" variant="contained" endIcon={<DeleteForeverIcon />} fullWidth>
                                        Clear Photo
                                    </Button>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography>
                                        Having uploaded your own photo, you agree that it meets the college student photo criteria, and understand that if it does not, a suitable replacement photo will be required.
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Button color="primary" variant="contained" fullWidth onClick={this.viewPhotoCriteria}>
                                        Click here to view the student photo criteria
                                    </Button>

                                    <PhotoCriteriaDialog setConditionsSeen={this.closePhotoCriteria} dialogOpen={this.state.viewingPhotoCriteria} />
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <ValidatorForm onSubmit={this.save} onError={this.onError} autoComplete="off" instantValidate={true}>
                                    {this.state.photoConditionsSeen &&

                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="I Disagree"
                                                trueLabel="I Agree"
                                                name="photoConditionsAccepted"
                                                value={this.state.photoConditionsAccepted}
                                                question=""
                                                handleChange={this.handleConditionsAcceptedChange}
                                                validators={['required', 'isBoolTrue']}
                                                errorMessages={['This field is required', 'All students are required to meet the College student photo criteria. Please ensure that your photo meets the criteria and select Yes.']}
                                            />
                                        </Grid>
                                    }

                                    {this.state.photoConditionsAccepted === true &&
                                        <React.Fragment>
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="I Disagree"
                                                    trueLabel="I Agree"
                                                    name="photoMarketingAccpeted"
                                                    value={this.state.photoMarketingAccpeted}
                                                    question="Would you allow you photo to be used in college for other uses such as marketing as well as on your college ID card?"
                                                    handleChange={this.handleMarketingAccpetedChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>

                                            <Grid container justify="center" alignItems="center" spacing={1}>
                                                <Grid item xs={12} sm={6} md={6} className={this.props.classes.buttonItem}>
                                                    <Button type="submit" color="primary" variant="contained" className={this.props.classes.button} fullWidth>
                                                        Confirm Photo and Submit
                                                            {this.state.saving && <CircularProgress color='secondary' size={24} className={this.props.classes.buttonProgress} />}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    }
                                </ValidatorForm>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    protected clearPhoto = () => {
        this.props.setPhoto(undefined);
    }

    protected closePhotoCriteria = () => {
        this.setState({ photoConditionsSeen: true, viewingPhotoCriteria: false })
    }

    protected viewPhotoCriteria = () => {
        this.setState({ viewingPhotoCriteria: true })
    }

    protected handleConditionsAcceptedChange = (event) => {
        this.setState({
            photoConditionsAccepted: (event.target.value === "true" ? true : false)
        });
    }

    protected handleMarketingAccpetedChange = (event) => {
        this.setState({
            photoMarketingAccpeted: (event.target.value === "true" ? true : false)
        });
    }

    protected onError = (event) => {
        console.log('on error');
        console.log(event);
    }

    protected save = (event) => {
        this.setState({ saving: true }, () => {
            if (this.state.photoMarketingAccpeted !== undefined) {
                this.props.setPhotoSubmited(this.state.photoMarketingAccpeted);
                this.setState({ saving: false });
            }
        });
    }

}

export default withStyles(styles)(DocumentUploadPhotoConfirmation);

